// import { FacebookOutlined, GoogleOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import axios from 'axios';
// import queryString from 'query-string';
import {
  memo,
  useCallback,
  useContext,
  // useEffect,
  // useMemo,
  useState,
} from 'react';
// import { useLocation } from 'react-router-dom';
import AlertMessage from '../../components/kits/AlertMessage';
import { AuthContext } from '../../contexts/AuthContext';
import { apiUrl, LOCAL_STORAGE_TOKEN_NAME } from '../../utils/constants';
// import setAuthToken from '../../utils/setAuthToken';

const Login = () => {
  // const location = useLocation();
  // const { token } = useMemo(
  //   () => queryString.parse(location.search),
  //   [location.search]
  // );
  const {
    authState: { user },
    loginUser,
    loadUser,
    // dispatch,
  } = useContext(AuthContext);
  const [alert, setAlert] = useState(null);
  const [twoFactorCode, setTwoFactorCode] = useState('');

  // function decodeToken(token) {
  //   try {
  //     if (token.split('.').length !== 3 || typeof token !== 'string') {
  //       return null;
  //     }

  //     var payload = token.split('.')[1];
  //     var padding = '='.repeat((4 - (payload.length % 4)) % 4);
  //     var base64 = payload.replace('-', '+').replace('_', '/') + padding;
  //     var jsonPayload = decodeURIComponent(
  //       window
  //         .atob(base64)
  //         .split('')
  //         .map(function (c) {
  //           return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  //         })
  //         .join('')
  //     );
  //     var decoded = JSON.parse(jsonPayload);
  //     return decoded;
  //   } catch (error) {
  //     return null;
  //   }
  // }
  // function isTokenExpired(token) {
  //   var decodedToken = decodeToken(token);
  //   var result = true;

  //   if (decodedToken && decodedToken.exp) {
  //     var expirationDate = new Date(0);
  //     expirationDate.setUTCSeconds(decodedToken.exp);
  //     result = expirationDate.valueOf() < new Date().valueOf();
  //   }

  //   return result;
  // }

  // useEffect(() => {
  //   if (token) {
  //     const decodedToken = decodeToken(token);
  //     const isExpired = isTokenExpired(token);
  //     if (!isExpired) {
  //       if (!decodedToken.isTwoFactorEnabled) {
  //         localStorage.setItem(LOCAL_STORAGE_TOKEN_NAME, token);
  //         loadUser();
  //       } else {
  //         setAuthToken(token);
  //         dispatch({
  //           type: LOAD_SUCCESS,
  //           payload: {
  //             isAuthenticated: false,
  //             user: decodedToken,
  //           },
  //         });
  //       }
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [token]);

  const onFinish = useCallback(
    async (values) => {
      try {
        const loginData = await loginUser(values);
        if (
          !loginData?.data?.user?.isSecondFactorAuthenticated &&
          loginData?.data?.user?.isTwoFactorEnabled
        ) {
        } else {
          setAlert({
            type: 'error',
            message: loginData?.message || 'Login failed',
          });
          setTimeout(() => setAlert(null), 3000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    [loginUser]
  );

  const onFinishFailed = useCallback((errorInfo) => {
    console.log('Failed:', errorInfo);
  }, []);

  const submitAuthenticate2FA = useCallback(
    async (e) => {
      e.preventDefault();
      if (twoFactorCode) {
        try {
          const response = await axios.post(`${apiUrl}/2fa/authenticate`, {
            twoFactorCode,
          });
          localStorage.setItem(
            LOCAL_STORAGE_TOKEN_NAME,
            response?.data?.data?.token
          );
          loadUser();
        } catch (error) {
          setAlert({
            type: 'error',
            message: error?.response?.data?.message || 'Authenticate failed',
          });
          setTimeout(() => setAlert(null), 3000);
        }
      }
    },
    [loadUser, twoFactorCode]
  );

  return (
    <>
      <Form
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Usrname/Email"
          name="username"
          rules={[
            {
              required: true,
              message: 'Please input your username!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <AlertMessage info={alert} />

        <Form.Item
          wrapperCol={{
            offset: 8,
            span: 16,
          }}
        >
          <Button type="primary" htmlType="submit">
            Login
          </Button>
        </Form.Item>

        {/* <Form.Item>
          <Link to="/register">Don't have an account?</Link>
          <br />
          <Link to="/reset-password">Forgot password</Link>
        </Form.Item> */}
      </Form>
      {user?.isTwoFactorEnabled && (
        <>
          <Input
            placeholder="Enter 2FA code here"
            style={{ marginTop: '5px' }}
            name={twoFactorCode}
            value={twoFactorCode}
            onChange={(event) => {
              setTwoFactorCode(event.target.value);
            }}
          />
          <Button
            type="primary"
            block
            style={{ marginTop: '10px', marginBottom: '10px' }}
            onClick={submitAuthenticate2FA}
          >
            Submit
          </Button>
        </>
      )}
      {/* <div className="social-login-btn">
        <GoogleLogin
          onSuccess={async (credentialResponse) => {
            const loginData = await loginUser({}, credentialResponse);
            if (!loginData?.data?.token) {
              setAlert({
                type: 'error',
                message: loginData?.message || 'Login failed',
              });
              setTimeout(() => setAlert(null), 3000);
            }
          }}
          onError={(error) => {
            setAlert({
              type: 'error',
              message: error?.message || 'Google login failed',
            });
            setTimeout(() => setAlert(null), 3000);
          }}
        />
      </div>
      <div>
        <FacebookLogin
          appId={process.env.REACT_APP_FACEBOOK_APP_ID}
          autoLoad={false}
          fields="name,email"
          callback={responseFacebook}
          cssClass="fb-btn"
          icon={
            <FacebookOutlined
              style={{ fontSize: '18px', marginRight: '5px' }}
            />
          }
        />
      </div> */}
      {/* <Button
        type="primary"
        block
        danger
        icon={<GoogleOutlined />}
        onClick={() => {
          window.location = `${apiUrl}/auth/google`;
        }}
      >
        Login with Google
      </Button>
      <Button
        type="primary"
        block
        icon={<FacebookOutlined />}
        style={{ marginTop: '10px' }}
        onClick={() => {
          window.location = `${apiUrl}/auth/facebook`;
        }}
      >
        Login with Facebook
      </Button> */}
    </>
  );
};

export default memo(Login);
